import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from "recharts";

interface TopicData {
  topic: string;
  accuracy: number;
  timeSpent: number;
  confidence: number;
}

interface TopicComparisonRadarProps {
  data: TopicData[];
}

export function TopicComparisonRadar({ data }: TopicComparisonRadarProps) {
  // Transform data for radar chart
  const radarData = data.slice(0, 6).map(topic => ({
    subject: topic.topic.substring(0, 15) + (topic.topic.length > 15 ? '...' : ''),
    accuracy: topic.accuracy,
    timeSpent: (topic.timeSpent / 60) * 10, // Normalize to 0-100 scale
    confidence: topic.confidence,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Topic Comparison</CardTitle>
        <CardDescription>Multi-dimensional view of your top topics</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <RadarChart data={radarData}>
            <PolarGrid className="stroke-muted" />
            <PolarAngleAxis 
              dataKey="subject" 
              className="text-xs"
            />
            <PolarRadiusAxis 
              angle={90} 
              domain={[0, 100]}
              className="text-xs"
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'hsl(var(--background))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px'
              }}
            />
            <Radar 
              name="Accuracy" 
              dataKey="accuracy" 
              stroke="hsl(var(--primary))" 
              fill="hsl(var(--primary))" 
              fillOpacity={0.3} 
            />
            <Radar 
              name="Confidence" 
              dataKey="confidence" 
              stroke="hsl(var(--chart-2))" 
              fill="hsl(var(--chart-2))" 
              fillOpacity={0.3} 
            />
          </RadarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
